/**
 * Normalizes an aircraft name for use in the new URL pattern
 * (/{locale}/aircraft/{id}/{name}), mirroring the slug algorithm
 * used by the new webapp.
 *
 * @param {string} name
 * @returns {string}
 */
const aircraftUrlSlug = name => {
  return String(name)
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
};

module.exports = aircraftUrlSlug;
exports = aircraftUrlSlug;
